import React from 'react';
import AchievementModal from './AchievementModal';
import useABC from '../Provider/TableContext/ABCContext';
import { abcToFormData, formDataToABC } from '../Functions/Helper/Model';
import { v4 as uuid } from 'uuid';
function new_uuid() { return "new-" + uuid() };
function useABCRoleState(formState, setFormState) {
    const [abcId, cacheABCId] = React.useState(formState?.abcId);
    const [roleId, cacheRoleId] = React.useState(formState?.roleId);
    const setABCId = React.useCallback((abcId) => {
        cacheABCId(abcId)
        if (typeof setFormState === "function") setFormState((od) => ({...od, abcId}))
    }, [setFormState]);
    const setRoleId = React.useCallback((roleId) => {
        cacheRoleId(roleId)
        if (typeof setFormState === "function") setFormState((od) => ({...od, roleId}))
    }, [setFormState]);
    React.useEffect(() => {
        const timeout = setTimeout(() => {
            cacheABCId(formState?.abcId);
            cacheRoleId(formState?.roleId);
        }, 100);
        return () => clearTimeout(timeout);
    }, [formState]);

    const onFormStateChange = React.useCallback((formState) => {
        cacheABCId(formState?.abcId);
        cacheRoleId(formState?.roleId);
        if (typeof setFormState === "function") {
            setFormState(formState);
        }
    }, [setFormState]);
    
    const newABC = React.useCallback(() => {
        setABCId(new_uuid());
    }, [setABCId]);
    const newRole = React.useCallback(() => {
        setRoleId(new_uuid());  
    }, [setRoleId]);
    return {abcId, roleId, setABCId, setRoleId, newABC, newRole, onFormStateChange};
}

export default function HookedAchievementModal({
    formState,
    setFormState,
    initialValue,
    onChange: _onChange,
    ...props
}) {
    const {
        abcId,
        roleId,
        setABCId,
        setRoleId,
        newABC,
        newRole,
        onFormStateChange
    } = useABCRoleState(formState, setFormState);
    const { abcs, processABCChanges } = useABC();
    const value = React.useMemo(() => {
        if (abcId && Array.isArray(abcs)) {
            const abc = abcs.find(abc => abc.mcb_abcid === abcId);
            if (abc) return abcToFormData(abc);
        }
        return undefined;
    }, [abcId, abcs]);
    
    const [stateValue, setStateValue] = React.useState(value || initialValue || {});

    React.useEffect(() => {
        if (value) setStateValue(value);
        else setStateValue(initialValue || {});
    }, [abcId, abcs, initialValue, value]);
    

    const onChange = React.useCallback((value) => {
        setStateValue(value);
        return value;
    }, []);
    
    const onSubmit = React.useCallback(async () => {
        const abcChanges = await (await processABCChanges([formDataToABC(stateValue)]))[0];
        setABCId(abcChanges.mcb_abcid);
        
    }, [processABCChanges, setABCId, stateValue]);

    const onClose  = React.useCallback(() => {
        onFormStateChange({ abcId: "", roleId: "" })
    }, [onFormStateChange])
    
    return (
        <AchievementModal
            onSubmit={onSubmit}
            onChange={onChange}
            onClose={onClose}
            roleId={roleId}
            setRoleId={setRoleId}
            newABC={newABC}
            newRole={newRole}
            value={stateValue}
            shown={!!(abcId || roleId)}
            {...props}
        />
    );
}